module.exports = __webpack_public_path__ + "static/media/time-remaing-retirement.9ab2087c.svg";